'use strict';

/**
 *  Module
 *
 * Description
 */
angular.module('manageConfigHeaderModule', []).controller('manageConfigHeaderCtrl', [
    '$rootScope',
    '$scope',
    'publicToolService',
    '$location',
    'versionCtrl',
    '$state',
    'loginService',
    'localStorageService',
    'modalDialog',
    'trsHttpService',
    'permissionService',
    'globleParamsSet',
    '$sessionStorage',
    function(
        $rootScope,
        $scope,
        publicToolService,
        $location,
        versionCtrl,
        $state,
        loginService,
        localStorageService,
        modalDialog,
        trsHttpService,
        permissionService,
        globleParamsSet,
        $sessionStorage
    ) {
        initStatus();
        initData();
        // $scope.headTab[$scope.currModule] = true;
        /**
         * [initStatus description]初始化函数
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.currModule = $location.path().split('/')[2];
            $scope.data = {
                user: {},
                headerName: '',
                headInfo: {},
            };
            $scope.status = {};
            // $scope.dologout=false;
            $scope.manageCfLogoutIframeSrc = null;
        }

        /**
         * [initData description]初始化
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            loginService.getCurrLoginUser().then(function(data) {
                $scope.data.user = data;
            });
            headPortrait();
            queryUserIsAdministrator();
            queryUserIsTenantAdmin();
            getHeaderInfo();
        }


        /**
         * [headPortrait description]获取头像
         *
         * @return  {[type]}  [return description]
         */
        function headPortrait() {
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'getUserHeadPic',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.headPic = data.USERHEAD[0].PERPICURL == '' ? './images/user_icon.jpg' : data.USERHEAD[0].PERPICURL;
            });
        }

        /**
         * [getNetworkResourceConfig description] 获取网络资源模块配置
         * @return  {[type]}  [return description]
         */
        function getHeaderInfo () {
            publicToolService.getHeaderInfo($scope);
        }
        
        /**
         * [groupmanageUser description] 进入部门稿库管理
         * @return {[type]} [description]
         */
        $scope.departmentmanageUser = function() {
            $scope.currModule = 'departmentmanu';
            $scope.$root.$broadcast('departmentBroadcast', true); // 通知左侧导航也更新数据
        };

        /**
         * [groupmanageUser description] 进入组织管理
         * @return {[type]} [description]
         */
        $scope.groupmanageUser = function() {
            $scope.currModule = 'groupmanage';
            $scope.$root.$broadcast('groupmanageUserBroadcast', 'all');
        };

        /**
         * [goToLogM description] 进入日志管理
         * @return {[type]} [description]
         */
        $scope.goToLogM = function() {
            $scope.currModule = 'logmanage';
        };

        /**
         * [goToProduct description] 进入产品管理
         * @return {[type]} [description]
         */
        $scope.goToProduct = function() {
            $scope.currModule = 'productmanage';
        };

        /**
         * [goToSys description] 进入系统管理
         * @return {[type]} [description]
         */
        $scope.goToSys = function() {
            $scope.currModule = 'sysmanage';
        };

        /**
         * [goToRoleManager description] 进入角色管理
         * @return {[type]} [description]
         */
        $scope.goToRoleManager = function() {
            $scope.currModule = 'rolemanage';
            // var userInfo = $sessionStorage.get('mlfCachedUser');
            // var groupId = userInfo.GroupId;
            $state.go('manageconfig.newrolemanage');
            // $state.go(
            //     'manageconfig.rolemanage',
            //     { groupid: groupId },
            //     {
            //         reload: 'manageconfig.rolemanage',
            //     }
            // );
        };

        /**
         * [logout description]管理配置退出
         * @return{[type]}[return description]
         */
        $scope.logout = function() {
            globleParamsSet.clearStroge();
            // localStorageService.remove('currLoginUser'); // session改变
            $sessionStorage.remove('currLoginUser');
            // localStorageService.remove('mlfCachedUser'); // session改变
            $sessionStorage.remove('mlfCachedUser');
            $('#unreadPrompt_js').hide(); // 关闭传稿提示框
            $.ajax({
                url: '/wcm/logout.jsp',
                method: 'get',
                async: false,
                success: function() {},
                error: function() {},
            });
            $state.go('front', {}, { reload: true });
        };

        /**
         * [queryUserIsAdministrator description] 判断用户是否是系统管理员
         * @return {[type]} [description]
         */
        function queryUserIsAdministrator() {
            permissionService
                .isAdministrator()
                .then(function(data) {
                    $scope.status.isAdministrator = data;
                })
                .finally(() => {
                    // getMessageNum();
                });
        }

        /**
         * [queryUserIsTenantAdmin description]判断是否是租户管理员
         *
         * @return  {[type]}  [return description]
         */
        function queryUserIsTenantAdmin() {
            permissionService.isTenantAdministrator().then(function(data) {
                $scope.status.isTenantAdministrator = data;
            });
        }

        /**
         * [tenantGo description]description：租户中心第一进入的跳转
         *
         * @return  {[type]}  [return description]
         */
        $scope.tenantGo = function() {
            $scope.currModule = 'tenantmanagement';
            var params = {
                serviceid: 'mlf_extuser',
                methodName: 'isAdministrator',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                if (data.ISADMINISTRATOR == 'false') {
                    $state.go('manageconfig.tenantmanagement.basicInfoSetting');
                } else {
                    $state.go('manageconfig.tenantmanagement.allTenantManage');
                }
            });
        };

        /**
         * [goToMessageCenter description] 进入消息中心
         * @return {[type]} [description]
         */
        $scope.goToMessageCenter = function() {
            $state.go('front.mc', {}, { reload: 'front.mc' });
            $scope.currModule = 'mc';
        };

        /**
         * [getMessageNum description]获取消息数量
         *
         * @return  {[type]}  [return description]
         */
        function getMessageNum() {
            if ($scope.status.isAdministrator) {
                return;
            }
            let params = {
                method: 'queryunreadmsgbyid',
                socketid: $scope.data.user.ID,
                serviceid: 'message',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'GET').then(function(res) {
                if (res.data) {
                    $scope.status.messageNum = res.data.unreadmsg > 99 ? '99+' : res.data.unreadmsg;
                }
            });
        }
        $rootScope.$on('updateMessage', (ev, data) => {
            if (data == 'update') {
                // getMessageNum(); // 暂时关闭
            }
        });
    },
]);
